import { transformRoutes } from '@backoffice-frontend/common'

const BaseVehicleMonitoringAreaRoutes = {
  route: '/vehicle-monitoring',
}

export const VehicleMonitoringAreaRoutes = transformRoutes(
  BaseVehicleMonitoringAreaRoutes,
)
